import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "formBody" };
const _hoisted_2 = { class: "listJobs-filters" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "listJobsCard-image" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["href", "title", "innerHTML"];
const _hoisted_7 = { class: "listJobsCard-info" };
const _hoisted_8 = { class: "listJobsCard-location" };
const _hoisted_9 = ["href", "title", "innerHTML"];
const _hoisted_10 = ["onClick", "innerHTML"];
const _hoisted_11 = { class: "listJobsCard-title" };
const _hoisted_12 = ["href", "innerHTML"];
const _hoisted_13 = { class: "listJobsCard-applicationDeadline" };
const _hoisted_14 = { class: "listJobsCard-deadlineAlarm" };
const _hoisted_15 = ["innerHTML"];
import { reactive, computed, watch } from 'vue';
import { MIN_SEARCH_LENGTH, splitWords } from './ListJobs';
import { ThemeFormField, ThemeButton } from '../../front/components';
var SortBy;
(function (SortBy) {
    SortBy["Newest"] = "nyaste";
    SortBy["Oldest"] = "aldsta";
    SortBy["Deadline"] = "ansokningsdag";
})(SortBy || (SortBy = {}));
var UrlParam;
(function (UrlParam) {
    UrlParam["Search"] = "sk";
    UrlParam["TermId"] = "yk";
    UrlParam["LocationCode"] = "lg";
    UrlParam["SortBy"] = "se";
})(UrlParam || (UrlParam = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'ListJobsApp',
    props: {
        listJobs: {}
    },
    setup(__props) {
        const UrlStateKeys = {
            [UrlParam.Search]: 'search',
            [UrlParam.TermId]: 'termId',
            [UrlParam.LocationCode]: 'locationCode',
            [UrlParam.SortBy]: 'sortBy',
        };
        const props = __props;
        const jsonData = props.listJobs.json;
        const initialUrl = new URL(window.location.href);
        const currentUrl = new URL(window.location.href);
        const state = reactive({
            search: initialUrl.searchParams.get(UrlParam.Search) || '',
            termId: parseInt(initialUrl.searchParams.get(UrlParam.TermId)) || props.listJobs.json.active_category_id || null,
            locationCode: parseInt(initialUrl.searchParams.get(UrlParam.LocationCode)) || null,
            sortBy: initialUrl.searchParams.get(UrlParam.SortBy) || null,
        });
        console.log({ initialUrl, currentUrl, state });
        watch(state, () => {
            for (const urlParam of Object.keys(UrlStateKeys)) {
                const stateKey = UrlStateKeys[urlParam];
                const value = state[stateKey];
                if (value) {
                    currentUrl.searchParams.set(urlParam, value.toString());
                }
                else {
                    currentUrl.searchParams.delete(urlParam);
                }
                window.history.replaceState({}, '', currentUrl.href);
            }
        });
        const searchTerms = computed(() => {
            return splitWords(state.search);
        });
        const resetOption = {
            label: 'Alla',
            key: null,
        };
        const placeholderTermIdOption = {
            label: 'Yrkeskategori',
            key: null,
        };
        const placeholderLocationOption = {
            label: 'Läge',
            key: null,
        };
        const categoriesOptions = computed(() => {
            const categoriesJson = jsonData.terms.map((term) => {
                return {
                    key: term.id,
                    label: term.name,
                    append: getJobsCountByCategory(term.id).toString(),
                };
            });
            return state.termId ? [resetOption].concat(categoriesJson) : categoriesJson;
        });
        const locationOptions = computed(() => {
            const locationOption = jsonData.municipalities.map((municipality) => {
                return {
                    key: municipality.code,
                    label: municipality.name,
                    append: getJobsCountByLocation(municipality.code).toString(),
                };
            });
            return state.locationCode ? [resetOption].concat(locationOption) : locationOption;
        });
        const placeholderSortOption = {
            label: 'Sortera efter',
            key: null,
        };
        const sortingVariants = [
            {
                key: SortBy.Newest,
                label: 'Nyaste först',
            },
            {
                key: SortBy.Oldest,
                label: 'Äldsta först',
            },
            {
                key: SortBy.Deadline,
                label: 'Ansökningsdag',
            },
        ];
        const filteredJobs = computed(() => {
            const arr = jsonData.jobs
                .filter(searchFilter)
                .filter(categoryFilter)
                .filter(locationFilter);
            if (state.sortBy) {
                arr.sort((a, b) => {
                    if (state.sortBy === SortBy.Newest) {
                        return a.published_date < b.published_date ? 1 : -1;
                    }
                    else if (state.sortBy === SortBy.Oldest) {
                        return a.published_date > b.published_date ? 1 : -1;
                    }
                    else if (state.sortBy === SortBy.Deadline) {
                        return a.application_deadline > b.application_deadline ? 1 : -1;
                    }
                    return 0;
                });
            }
            return arr;
        });
        function searchFilter(job) {
            if (state.search.length <= MIN_SEARCH_LENGTH) {
                return true;
            }
            return searchTerms.value.some(searchTerm => { var _a; return (_a = job.search_terms) === null || _a === void 0 ? void 0 : _a.some((jobTerm) => jobTerm.includes(searchTerm)); });
        }
        function categoryFilter(job) {
            return !state.termId || (state.termId > 1 && job.categories_ids.includes(state.termId));
        }
        function locationFilter(job) {
            return !state.locationCode || job.municipality_code === state.locationCode;
        }
        function getJobsCountByLocation(locationCode) {
            return jsonData.jobs.filter((job) => job.municipality_code === locationCode && (!state.termId || categoryFilter(job))).length;
        }
        function getJobsCountByCategory(termId) {
            return jsonData.jobs.filter((job) => job.categories_ids.includes(termId) && (!state.locationCode || locationFilter(job))).length;
        }
        /**
         * Highlights matches in a string.
         * NOTE this function is not optimized for long texts. In that case you should use a library like fuzzy-search.
         * That would also give an opportunity to use highlights to perform the search itself, as a byproduct of highlighting
         * @link https://www.npmjs.com/package/fuzzy-search
         */
        function highlightMatches(str) {
            if (state.search.length <= MIN_SEARCH_LENGTH) {
                return str;
            }
            const regex = new RegExp(`(${searchTerms.value.join('|')})`, 'gi');
            return str.replace(regex, match => `<span class="this-highlight">${match}</span>`);
        }
        function toggleLocation(location = null) {
            state.locationCode = state.locationCode === location ? null : location;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(jsonData).jobs.length > 1)
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 0,
                        to: _ctx.listJobs.getElementById('filtersWrapper')
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_unref(ThemeFormField), {
                                    type: "text",
                                    placeholder: "Sök jobb, arbetsgivare...",
                                    modelValue: state.search,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.search) = $event)),
                                    appendIcon: "magnifying-glass"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_unref(ThemeFormField), {
                                    type: "select-custom",
                                    placeholder: placeholderLocationOption,
                                    options: locationOptions.value,
                                    modelValue: state.locationCode,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((state.locationCode) = $event))
                                }, null, 8, ["options", "modelValue"]),
                                _createVNode(_unref(ThemeFormField), {
                                    type: "select-custom",
                                    placeholder: placeholderTermIdOption,
                                    options: categoriesOptions.value,
                                    modelValue: state.termId,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((state.termId) = $event))
                                }, null, 8, ["options", "modelValue"]),
                                _createVNode(_unref(ThemeFormField), {
                                    type: "select-custom",
                                    placeholder: placeholderSortOption,
                                    options: sortingVariants,
                                    modelValue: state.sortBy,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((state.sortBy) = $event))
                                }, null, 8, ["modelValue"])
                            ])
                        ])
                    ], 8, ["to"]))
                    : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_Teleport, {
                    to: _ctx.listJobs.getElementById('listJobsWrapper')
                }, [
                    (filteredJobs.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            innerHTML: _unref(jsonData).no_entries_html
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    _createVNode(_TransitionGroup, { name: "listJobsTransition" }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredJobs.value, (job) => {
                                var _a;
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "listJobsCard",
                                    key: job.id
                                }, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", {
                                            innerHTML: job.image_html || _unref(jsonData).placeholder_image_html
                                        }, null, 8, _hoisted_5),
                                        ((_a = job.employer) === null || _a === void 0 ? void 0 : _a.logo_html)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "listJobsCard-employerLogo",
                                                href: job.employer.url,
                                                title: `Visa alla jobb hos ${job.employer.title}`,
                                                innerHTML: job.employer.logo_html
                                            }, null, 8, _hoisted_6))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            false
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (job.employer)
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 0,
                                                            href: job.employer.url,
                                                            title: `Visa alla jobb hos ${job.employer.title}`,
                                                            innerHTML: `[${highlightMatches(job.employer.title)}] `
                                                        }, null, 8, _hoisted_9))
                                                        : _createCommentVNode("", true)
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (job.municipality)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 1,
                                                    onClick: ($event) => (toggleLocation(job.municipality_code)),
                                                    innerHTML: `${highlightMatches(job.municipality.full_name)}`
                                                }, null, 8, _hoisted_10))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("h3", _hoisted_11, [
                                            _createElementVNode("a", {
                                                href: job.permalink,
                                                innerHTML: highlightMatches(job.title)
                                            }, null, 8, _hoisted_12)
                                        ]),
                                        _createElementVNode("p", _hoisted_13, [
                                            _createTextVNode(" Sista ansökningsdag " + _toDisplayString(job.application_deadline) + " ", 1),
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(job.deadline_alarm), 1)
                                        ]),
                                        _createElementVNode("div", {
                                            class: "listJobsCard-excerpt",
                                            innerHTML: highlightMatches(job.excerpt)
                                        }, null, 8, _hoisted_15),
                                        _createVNode(_unref(ThemeButton), {
                                            href: job.permalink,
                                            class: "listJobsCard-permalink",
                                            type: "link",
                                            title: "Läs mer och ansök här!",
                                            size: "small",
                                            color: "tert",
                                            icon: "arrow-right-long"
                                        }, null, 8, ["href"])
                                    ])
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    })
                ], 8, ["to"]))
            ], 64));
        };
    }
});
